const ClockHistory = () => {
  const pStyles = "text-slate-600";
  const aStyles = "text-sky-500 py-2.5";
  const liStyles = "mb-2";
  return (
    <div className="flex flex-col justify-center">
      <div className="p-5 text-center text-xl text-slate-600 font-medium">
        A little history and context
      </div>
      <div className="p-5 text-left space-y-2 bg-stone-50 border rounded-md">
        <p className={pStyles}>
          The Guinness Book of Records describes it as follows: "This is the
          first clock in the world that operates according to the principle of
          the set theory."
        </p>
        <p className={pStyles}>
          According to the sign posted on the clock itself, "the clock was
          originally placed on the{" "}
          <span title="A famous avenue in Berlin">Kurfürstendamm</span> by the
          inventor D. Binninger on 18 June 1975. It has been located in the
          present position since 23 May 1996. The clock is on long-term loan
          from the widow of the inventor, Ms Monika Binninger."
        </p>
        <div className="text-center py-2.5">
          <ul>
            <li className={liStyles}>
              <a
                className={aStyles}
                href="https://www.atlasobscura.com/places/mengenlehreuhr"
                rel="noreferrer"
                target="_blank"
              >
                Read more about the Berlin-Uhr at Atlas Obscura
              </a>
            </li>
            <li className={liStyles}>
              <a
                className={aStyles}
                href="https://en.wikipedia.org/wiki/Mengenlehreuhr"
                rel="noreferrer"
                target="_blank"
              >
                Read more about the Berlin-Uhr on Wikipedia
              </a>
            </li>
            <li className={liStyles}>
              <a
                className={aStyles}
                href="https://goo.gl/maps/5X44sYkWEfeJodom6"
                rel="noreferrer"
                target="_blank"
              >
                View on Google Maps
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export { ClockHistory };
